import { useEffect, useState } from 'react';

// Breakpoint constants matching Tailwind's md and lg breakpoints
const TABLET_MIN_WIDTH = 768;
const TABLET_MAX_WIDTH = 1024;

export function useTablet() {
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const checkTabletMode = () => {
      const width = window.innerWidth;
      setIsTablet(width >= TABLET_MIN_WIDTH && width < TABLET_MAX_WIDTH);
    };

    checkTabletMode();
    window.addEventListener('resize', checkTabletMode);
    return () => window.removeEventListener('resize', checkTabletMode);
  }, []);

  return isTablet;
}

// Export constants for use in other files
export const TABLET_BREAKPOINTS = {
  MIN: TABLET_MIN_WIDTH,
  MAX: TABLET_MAX_WIDTH,
} as const;
